import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '../../../';
import { DefaultLinkWrapper } from './NavItem';

var NavMenuItem = /*#__PURE__*/function (_React$Component) {
  _inherits(NavMenuItem, _React$Component);

  var _super = _createSuper(NavMenuItem);

  function NavMenuItem() {
    _classCallCheck(this, NavMenuItem);

    return _super.apply(this, arguments);
  }

  _createClass(NavMenuItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          href = _this$props.href,
          isActive = _this$props.isActive,
          isOpen = _this$props.isOpen,
          hasSub = _this$props.hasSub,
          newTab = _this$props.newTab,
          onClick = _this$props.onClick,
          _this$props$LinkWrapp = _this$props.LinkWrapper,
          LinkWrapper = _this$props$LinkWrapp === void 0 ? DefaultLinkWrapper : _this$props$LinkWrapp,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, ["children", "href", "isActive", "isOpen", "hasSub", "newTab", "onClick", "LinkWrapper", "className"]);

      var props = _objectSpread({
        className: classNames('cloud-ui-nav-menu-link', className, {
          'is-active': isActive,
          'is-open': isOpen,
          'has-sub': hasSub
        }),
        href: href,
        onClick: onClick
      }, rest);

      if (newTab) {
        props.target = '_blank';
        props.rel = 'noopener noreferrer';
      }

      var Item = href ? LinkWrapper : 'button';
      return /*#__PURE__*/React.createElement(Item, props, children, isActive && !hasSub && /*#__PURE__*/React.createElement(Icon, {
        name: "check"
      }));
    }
  }]);

  return NavMenuItem;
}(React.Component);

_defineProperty(NavMenuItem, "propTypes", {
  href: PropTypes.string,
  isActive: PropTypes.bool,
  isOpen: PropTypes.bool,
  hasSub: PropTypes.bool,
  newTab: PropTypes.bool,
  onClick: PropTypes.func,
  LinkWrapper: PropTypes.func
});

export default NavMenuItem;